import {
  ApplicationCreatedBy,
  ApplicationStatus
} from "shared/model/IApplication";
import { MemberBotType } from "shared/pages/MembersBotPage";
import { PaymentStatus } from "shared/model/ITransaction";

import { IMembersChatState } from "./MembersChatModule";
import MembersChatSelectors from "./MembersChatSelectors";

export const selectMemberBotType = (state: IMembersChatState) => {
  const application = MembersChatSelectors.application(state);
  const isAssignedApplication = MembersChatSelectors.isAssignedApplication(
    state
  );

  if (application) {
    const {
      originalPhotoIdUrl,
      photoId,
      authenticatedBankAccount,
      status,
      paymentMethodSubmitted,
      metadata,
      monthlyPaymentAmount,
      paymentStatus
    } = application!;
    const didFinishFirstBot = originalPhotoIdUrl || photoId;
    const createdByMember = metadata.createdBy === ApplicationCreatedBy.Member;
    const hasFailedPayment =
      paymentMethodSubmitted && paymentStatus === PaymentStatus.Declined;

    if (isAssignedApplication) {
      if (hasFailedPayment) {
        return MemberBotType.Payments;
      } else if (
        status === ApplicationStatus.Approved &&
        !paymentMethodSubmitted
      ) {
        return MemberBotType.Payments;
      } else if (!didFinishFirstBot) {
        return MemberBotType.Dashbot;
      } else if (!authenticatedBankAccount) {
        return createdByMember
          ? MemberBotType.MySalaryoBankAuth
          : MemberBotType.BankAuth;
      } else if (
        createdByMember &&
        !paymentMethodSubmitted &&
        monthlyPaymentAmount
      ) {
        return MemberBotType.Payments;
      } else {
        return MemberBotType.Status;
      }
    } else {
      if (hasFailedPayment) {
        return MemberBotType.Payments;
      } else if (
        status === ApplicationStatus.Approved &&
        !paymentMethodSubmitted
      ) {
        return MemberBotType.Payments;
      } else if (!didFinishFirstBot) {
        return MemberBotType.MySalaryoPhotoId;
      } else if (!authenticatedBankAccount) {
        return createdByMember
          ? MemberBotType.MySalaryoBankAuth
          : MemberBotType.BankAuth;
      } else {
        return MemberBotType.Status;
      }
    }
  } else {
    return MemberBotType.MySalaryo;
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/membersChat/MemberChatBotType.ts